import { LoaderFunction } from 'react-router-dom';

import {
  ContentfulInstructorLedTraining,
  ContentfulInstructorLedTrainingResponse,
  GET_INSTRUCTOR_LED_TRAINING,
} from 'src/graphql/queries/GetInstructorLedTraining';
import { fetchGraphQL } from 'src/services/contentful/client';

export interface PartnersLoaderProps {
  courseId: string;
  iltData: ContentfulInstructorLedTraining;
}

interface GetInstructorLedTrainingQueryVariables {
  slug: string;
  preview: boolean;
}

const getInstructorLedTrainingData = async (
  slug: string,
  preview: boolean,
): Promise<ContentfulInstructorLedTraining | undefined> => {
  try {
    const response = await fetchGraphQL<
      ContentfulInstructorLedTrainingResponse,
      GetInstructorLedTrainingQueryVariables
    >(GET_INSTRUCTOR_LED_TRAINING, {
      slug,
      preview,
    });

    return response.instructorLedTrainingCollection.items[0];
  } catch (error) {
    return undefined;
  }
};

export const loader: LoaderFunction = async ({ params }): Promise<PartnersLoaderProps> => {
  const courseId = params.courseId ?? '';
  const preview = false;

  const iltData = await getInstructorLedTrainingData(courseId, preview);

  if (!iltData) {
    throw new Response('Instructor-led training not found', { status: 404 });
  }

  return {
    courseId,
    iltData,
  };
};
